var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1689,
    cy: 26.5,
    rx: 25.1689,
    ry: 26,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7256 16.5373C25.5783 16.4876 25.4217 16.4876 25.2744 16.5373L10.5705 21.5067C9.80983 21.7638 9.80983 22.9962 10.5705 23.2533L13.1 24.1082V29.1717C12.6485 29.3447 12.325 29.8114 12.325 30.36V36.7364C12.325 37.1581 12.6404 37.5 13.0295 37.5H13.9455C14.3346 37.5 14.65 37.1581 14.65 36.7364V30.36C14.65 29.8114 14.3265 29.3447 13.875 29.1717V24.3701L25.2744 28.2227C25.4217 28.2724 25.5783 28.2724 25.7256 28.2227L40.4295 23.2533C41.1902 22.9962 41.1902 21.7638 40.4295 21.5067L25.7256 16.5373ZM16.975 28.2037C16.975 27.6375 17.4813 27.2334 17.9801 27.4016L25.2744 29.8599C25.4217 29.9096 25.5783 29.9096 25.7256 29.8599L33.0199 27.4016C33.5187 27.2334 34.025 27.6375 34.025 28.2037V32.4102V32.4102C34.025 33.7981 30.2082 34.9232 25.5 34.9232C20.7918 34.9232 16.975 33.7981 16.975 32.4102V32.4102V28.2037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIconRound);
export default __webpack_public_path__ + "static/media/education-icon-round.7bbe44cfee223cce289803452358ded3.svg";
export { ForwardRef as ReactComponent };